import { NANG_LUC_NHAN_SU_LIST } from "../apis/_index";
import ServiceUtils from "../utils/services";

export const listNanglucnhasuAction = (body: any) => {
    return new Promise(async resolve => {
        // dispatch({
        //     type: 'LISTNANGLUCNHANSU', data: initialState
        // });
        return await ServiceUtils.postV2(NANG_LUC_NHAN_SU_LIST, body)
            .then((res: any) => {

                resolve({
                    status: true,
                    data: res.data.Data
                });
            })
            .catch((err: any) => {
                resolve({
                    status: false,
                    err: err
                });
            })
    })
}





